import 'jquery';

class jQueryController {
    constructor() {
        this.components = [];
        this.ready();
    }

    ready() {
        var components = this.components;
        jQuery(($) => {
            components.forEach(component => component.ready($))
        });
    }

    addComponents(components) {
        components.forEach(component => this.addComponent(component))
    }

    addComponent(component) {
        this.components.push(component);
    }
}

const $controller = new jQueryController()

export default $controller
